import { render, staticRenderFns } from "./add_exhibition.vue?vue&type=template&id=b69dbe72&scoped=true&"
import script from "./add_exhibition.vue?vue&type=script&lang=js&"
export * from "./add_exhibition.vue?vue&type=script&lang=js&"
import style0 from "./add_exhibition.vue?vue&type=style&index=0&id=b69dbe72&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b69dbe72",
  null
  
)

export default component.exports